import { createClient } from '@supabase/supabase-js'

// Project ID: djiodnjshziftmhandrb
const SUPABASE_URL = 'https://djiodnjshziftmhandrb.supabase.co'
const SUPABASE_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6ImRqaW9kbmpzaHppZnRtaGFuZHJiIiwicm9sZSI6ImFub24iLCJpYXQiOjE3ODA5NDAxODUsImV4cCI6MjA5NjUxNjE4NX0.a4PdbDrA-t4pg-2XJ7ZZ-6d53denZcuNS92tlKw9wik'

if (!SUPABASE_URL || !SUPABASE_ANON_KEY) {
  throw new Error('Missing Supabase variables');
}

export default createClient(SUPABASE_URL, SUPABASE_ANON_KEY, {
  auth: {
    persistSession: true,
    autoRefreshToken: true
  }
})